import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

interface ConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    message?: string;
    cancelText?: string;
    confirmText?: string;
    confirmButtonColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
    disabled?: boolean;
}

export default function ConfirmDialog({
    open,
    onClose,
    onConfirm,
    title = "Confirmar",
    message = "Tem certeza que deseja realizar esta ação?",
    cancelText = "Cancelar",
    confirmText = "Confirmar",
    confirmButtonColor = "primary",
    disabled = false
}: ConfirmDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {cancelText}
                </Button>
                <Button 
                    onClick={onConfirm} 
                    variant="contained" 
                    color={confirmButtonColor}
                    disabled={disabled}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
